import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=33d09160&scoped=true&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"
import style0 from "./contact.vue?vue&type=style&index=0&id=33d09160&prod&lang=css&"
import style1 from "./contact.vue?vue&type=style&index=1&id=33d09160&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d09160",
  null
  
)

export default component.exports